import React, { useContext } from 'react';

// mobx components
import { observer } from 'mobx-react';
import AssetStoreContext from '../../stores/AssetStore';

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
// import Typography from '@material-ui/core/Typography';

// core components
// import CustomSlider from '../CustomSlider/CustomSlider';
import CustomInput from '../CustomInput/CustomInput';

const Asset = observer(props => {
  const assetStore = useContext(AssetStoreContext);
  const { asset, lang } = props;

  const handleChangeText = name => event => {
    assetStore.setDetailAsset('assetsList', asset.value, name, event.target.value);
  };

  const handleSlideValueAmount = value => {
    assetStore.setDetailAsset('assetsList', asset.value, 'amount', value);
  };

  return (
    <div
      style={{
        paddingTop: '10px',
        paddingBottom: '10px',
        paddingLeft: '20px',
        // border: '1px solid #dbdbdb',
        backgroundColor: '#f4f4f4e8',
        paddingRight: '20px',
      }}
    >
      <div>
        <p
          style={{
            color: '#000',
            fontSize: '20px',
            lineHeight: '135%',
            width: '100%',
            wordBreak: 'break-word',
            margin: '0px',
            fontWeight: '600',
          }}
        >
          {lang.goalDescription}
        </p>
        <TextField
          id="nameTxt"
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          // onChange={handleChangeText('description')}
          onChange={handleChangeText('description')}
          value={assetStore.assetsList.find(x => x.name === asset.value).description}
        />
        {/* <TextField
        id="nameTxt"
        label="Valor"
        style={{ margin: 8 }}
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
        }}
        // onChange={handleChangeText('description')}
      /> */}
      </div>
      <br />
      <div>
        {/* <Typography gutterBottom>
          Valor:{' '}
          <span
            style={{
              color: '#000',
              fontSize: '18px',
              lineHeight: '135%',
              width: '100%',
              wordBreak: 'break-word',
              margin: '0px',
              fontWeight: '600',
            }}
          >
            ${assetStore.assetsList.find(x => x.name === asset.value).amount}
          </span>
        </Typography> */}
        {/* <CustomSlider
          defaultValue={assetStore.assetsList.find(x => x.name === asset.value).amount}
          handleChangeValue={handleSlideValueAmount}
        /> */}
        <p
          style={{
            color: '#000',
            fontSize: '20px',
            lineHeight: '135%',
            width: '100%',
            wordBreak: 'break-word',
            // margin: '0px',
            fontWeight: '600',
          }}
        >
          {lang.assetValue}
        </p>
        <CustomInput
          defaultValue={assetStore.assetsList.find(x => x.name === asset.value).amount}
          handleChangeValue={handleSlideValueAmount}
        />
      </div>
    </div>
  );
});

export default Asset;
